import type { ReactNode } from "react";
import { GenericLabel } from "./GenericLabel";

type Props = {
  title?: ReactNode;
  imageUrl?: string;
  size?: number;
};

export const SeasonLabel = ({ title, imageUrl, size }: Props) => {
  return <GenericLabel title={title} imageUrl={imageUrl} size={size} avatarIcon="fa-calendar-days" />;
};
